export default __webpack_public_path__ + "static/media/bass-pic.3cffdb0b.jpg";